module.exports = __webpack_public_path__ + "img/stop-9.ef44e9b2.jpg";